import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { formatBRL, formatDate } from '../../components/shared';
import api from '../../services/api';

const STATUS_INFO = {
  pendente:  { label: 'Aguardando confirmação', icon: '⏳', color: '#f59e0b', bg: '#fef9c3', step: 1 },
  aceito:    { label: 'Pedido confirmado!',       icon: '✅', color: '#3b82f6', bg: '#dbeafe', step: 2 },
  em_rota:   { label: 'Saiu para entrega!',       icon: '🛵', color: '#8b5cf6', bg: '#ede9fe', step: 3 },
  entregue:  { label: 'Pedido entregue!',          icon: '🎉', color: '#22c55e', bg: '#dcfce7', step: 4 },
  retirado:  { label: 'Pedido retirado!',          icon: '🎉', color: '#22c55e', bg: '#dcfce7', step: 4 },
  cancelado: { label: 'Pedido cancelado',          icon: '❌', color: '#ef4444', bg: '#fee2e2', step: 0 },
};

export default function Acompanhar() {
  const { pedido_id } = useParams();
  const navigate = useNavigate();
  const [pedido, setPedido]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro]       = useState(false);

  const carregar = () => {
    api.get(`/acompanhar/${pedido_id}`)
      .then(r => setPedido(r.data))
      .catch(() => setErro(true))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    carregar();
    const timer = setInterval(carregar, 30000); // atualiza a cada 30s
    return () => clearInterval(timer);
  }, [pedido_id]);

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>🍽</div>
        <div style={{ width: 32, height: 32, border: '3px solid #eee', borderTopColor: '#FF6B35',
          borderRadius: '50%', animation: 'spin .7s linear infinite', margin: '0 auto' }} />
      </div>
    </div>
  );

  if (erro || !pedido) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 20 }}>
      <div>
        <div style={{ fontSize: '3rem', marginBottom: 12 }}>😕</div>
        <h2>Pedido não encontrado</h2>
        <button onClick={() => navigate(-1)} style={{
          marginTop: 16, background: '#FF6B35', color: '#fff', border: 'none',
          borderRadius: 12, padding: '12px 24px', cursor: 'pointer', fontFamily: 'inherit', fontWeight: 700,
        }}>Voltar</button>
      </div>
    </div>
  );

  const info = STATUS_INFO[pedido.status] || STATUS_INFO.pendente;
  const steps = [
    { label: 'Recebido',   icon: '📋', step: 1 },
    { label: 'Confirmado', icon: '✅', step: 2 },
    { label: 'Em rota',    icon: '🛵', step: 3 },
    { label: 'Entregue',   icon: '🎉', step: 4 },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#F8F7F4', fontFamily: "'Sora', sans-serif" }}>
      <header style={{ background: '#1A1A2E', padding: '14px 20px' }}>
        <div style={{ maxWidth: 560, margin: '0 auto', display: 'flex', alignItems: 'center', gap: 12 }}>
          <button onClick={() => navigate(-1)} style={{
            background: 'rgba(255,255,255,.1)', border: 'none', color: '#fff',
            borderRadius: 10, width: 36, height: 36, cursor: 'pointer', fontSize: '1.1rem',
          }}>←</button>
          <h1 style={{ color: '#fff', fontSize: '1rem', fontWeight: 800, margin: 0 }}>Acompanhar Pedido</h1>
          <button onClick={carregar} style={{
            background: 'rgba(255,255,255,.1)', border: 'none', color: '#fff',
            borderRadius: 10, padding: '6px 12px', cursor: 'pointer',
            fontSize: '.75rem', marginLeft: 'auto', fontFamily: 'inherit',
          }}>🔄 Atualizar</button>
        </div>
      </header>

      <div style={{ maxWidth: 560, margin: '0 auto', padding: '20px 16px 40px' }}>

        {/* Status principal */}
        <div style={{ background: info.bg, border: `2px solid ${info.color}20`,
          borderRadius: 20, padding: 24, textAlign: 'center', marginBottom: 20 }}>
          <div style={{ fontSize: '3rem', marginBottom: 8 }}>{info.icon}</div>
          <div style={{ fontWeight: 800, fontSize: '1.2rem', color: info.color }}>{info.label}</div>
          <div style={{ fontSize: '.8rem', color: '#888', marginTop: 4 }}>
            Atualizado automaticamente a cada 30 segundos
          </div>
        </div>

        {/* Progress bar (só se não cancelado) */}
        {pedido.status !== 'cancelado' && pedido.tipo === 'entrega' && (
          <div style={{ background: '#fff', borderRadius: 16, padding: 20, marginBottom: 16, border: '1px solid #eee' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative' }}>
              <div style={{
                position: 'absolute', top: 18, left: '12.5%', right: '12.5%',
                height: 3, background: '#eee', zIndex: 0,
              }}>
                <div style={{
                  height: '100%', background: '#FF6B35',
                  width: `${Math.max(0, (info.step - 1) / 3 * 100)}%`,
                  transition: 'width .4s',
                }} />
              </div>
              {steps.map(s => (
                <div key={s.step} style={{ textAlign: 'center', flex: 1, position: 'relative', zIndex: 1 }}>
                  <div style={{
                    width: 36, height: 36, borderRadius: '50%', margin: '0 auto 8px',
                    background: info.step >= s.step ? '#FF6B35' : '#eee',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '1rem', transition: 'background .3s',
                  }}>{info.step >= s.step ? s.icon : '○'}</div>
                  <div style={{ fontSize: '.7rem', color: info.step >= s.step ? '#FF6B35' : '#aaa', fontWeight: 600 }}>
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Resumo do pedido */}
        <div style={{ background: '#fff', borderRadius: 16, padding: 20, marginBottom: 16, border: '1px solid #eee' }}>
          <h3 style={{ fontWeight: 800, marginBottom: 14, fontSize: '.95rem' }}>📋 Resumo do pedido</h3>
          <div style={{ fontSize: '.8rem', color: '#888', marginBottom: 12, fontFamily: 'monospace' }}>
            #{pedido.id?.slice(0,8)}...
          </div>
          {pedido.itens?.map((i, idx) => (
            <div key={idx} style={{ display: 'flex', justifyContent: 'space-between',
              fontSize: '.875rem', marginBottom: 6 }}>
              <span style={{ color: '#555' }}>{i.quantidade}x {i.descricao_produto}</span>
              <span style={{ fontWeight: 700 }}>{formatBRL(i.valor_total)}</span>
            </div>
          ))}
          <div style={{ borderTop: '1px solid #eee', paddingTop: 12, marginTop: 12,
            display: 'flex', justifyContent: 'space-between', fontWeight: 800 }}>
            <span>Total</span>
            <span style={{ color: '#FF6B35', fontSize: '1.05rem' }}>{formatBRL(pedido.valor_total)}</span>
          </div>
        </div>

        {/* Dados do cliente */}
        <div style={{ background: '#fff', borderRadius: 16, padding: 20, marginBottom: 16, border: '1px solid #eee' }}>
          <h3 style={{ fontWeight: 800, marginBottom: 12, fontSize: '.95rem' }}>👤 Dados do pedido</h3>
          {[
            { l: 'Cliente',    v: pedido.nome_cliente },
            { l: 'Telefone',   v: pedido.telefone },
            { l: 'Tipo',       v: pedido.tipo === 'entrega' ? '🛵 Entrega' : '🏪 Retirada' },
            { l: 'Pagamento',  v: pedido.forma_pagamento?.replace('_',' ') },
            pedido.tipo === 'entrega' && { l: 'Endereço', v: `${pedido.endereco}, ${pedido.numero} - ${pedido.bairro}, ${pedido.cidade}/${pedido.estado}` },
          ].filter(Boolean).map(({ l, v }) => v && (
            <div key={l} style={{ display: 'flex', gap: 8, marginBottom: 8, fontSize: '.875rem' }}>
              <span style={{ color: '#999', minWidth: 80 }}>{l}</span>
              <span style={{ fontWeight: 600 }}>{v}</span>
            </div>
          ))}
        </div>

        {/* Histórico de status */}
        {pedido.historico?.length > 0 && (
          <div style={{ background: '#fff', borderRadius: 16, padding: 20, border: '1px solid #eee' }}>
            <h3 style={{ fontWeight: 800, marginBottom: 14, fontSize: '.95rem' }}>📍 Histórico</h3>
            {[...pedido.historico].reverse().map((h, i) => (
              <div key={i} style={{ display: 'flex', gap: 12, marginBottom: 12, alignItems: 'flex-start' }}>
                <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#FF6B35',
                  marginTop: 5, flexShrink: 0 }} />
                <div>
                  <div style={{ fontWeight: 700, fontSize: '.85rem', textTransform: 'capitalize' }}>
                    {(STATUS_INFO[h.status_novo]?.label || h.status_novo).replace('_', ' ')}
                  </div>
                  <div style={{ fontSize: '.75rem', color: '#aaa' }}>{formatDate(h.data_hora)}</div>
                  {h.observacao && <div style={{ fontSize: '.8rem', color: '#666', marginTop: 2 }}>{h.observacao}</div>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
